// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { CartGroup } from "@eisinc/App/Services/ScheduleOrderService";
import { createContext, useContext } from "react";

export interface ScheduledLinesContextModel {
    cartId?: string;
    hasScheduledDeliveries?: boolean;
    canCustomerScheduleOrders?: boolean;
    groups?: CartGroup[];
    errorMessage?: string;
}

const DEFAULT_SCHEDULED_LINES: ScheduledLinesContextModel = {
    cartId: "",
    hasScheduledDeliveries: false,
    canCustomerScheduleOrders: false,
    groups: [],
    errorMessage: "",
};

export const ScheduledLinesContext = createContext<ScheduledLinesContextModel | undefined>(undefined);

export const useScheduledLines = (): ScheduledLinesContextModel => {
    return useContext(ScheduledLinesContext) ?? DEFAULT_SCHEDULED_LINES;
};
